module.exports = __webpack_public_path__ + "static/media/fpi-2-2-18-Dark.13d2a25c.png";